import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { gcBaseThemePreset } from '../theme/base-theme.preset';
import { cancelPendingRequestsInterceptor } from '@app/core/interceptors/cancel-pending-requests-interceptor/cancel-pending-requests.interceptor';
import { errorInterceptor } from '@app/core/interceptors/error-interceptor/error.interceptor';
import { authTokenInterceptor } from '@app/core/authentication/interceptors/auth-token.interceptor';
import { csrfTokenInterceptor } from '@app/core/interceptors/csrf-token-interceptor/csrf-token.interceptor';
import { queueRequestsInterceptor } from '@app/core/interceptors/queue-requests-interceptor/queue-requests.interceptor';
import { DatepickerDateFormat } from '@app/core/enums/date-format.enum';
import { provideCoreDependencies } from '@app/core/core.dependencies';
import { initializeChart } from '@app/core/providers/chart/chart-provider';
import { loadRuntimeEnv } from '../environments/common/runtime-env-loader';
import { provideI18n } from '@app/core/i18n/i18n.provider';
import { NgxPermissionsModule } from 'ngx-permissions';
import { provideMarkdown } from 'ngx-markdown';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => loadRuntimeEnv()),
    provideCoreDependencies(),
    provideAppInitializer(() => initializeChart()),
    provideHttpClient(
      withInterceptors([
        csrfTokenInterceptor,
        authTokenInterceptor,
        cancelPendingRequestsInterceptor,
        errorInterceptor,
        queueRequestsInterceptor,
      ])
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    providePrimeNG({
      translation: {
        dateFormat: DatepickerDateFormat.MMMDDYYYY,
      },
      theme: {
        preset: gcBaseThemePreset,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    provideAngularSvgIcon(),
    provideI18n(),
    provideMarkdown(),
    importProvidersFrom(NgxPermissionsModule.forRoot()),
  ],
};
